import { useState, createContext, useContext, useMemo, useEffect } from "react";
import { sessionStorageUtil } from "../utils/storage";
// import { useLocation } from "react-router-dom";
// import { sessionStorageUtil } from "../utils/storage";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const token = sessionStorageUtil.getAccessToken();

    if (token !== null && token !== "") {
      // return {};

      const userData = sessionStorageUtil.getUserData();

      if (userData !== null) {
        return userData;
      } else {
        return null;
      }
    }

    return null;
  });
  const [loading, setLoading] = useState(true);

  const login = (userData) => {
    setUser(userData);
  };

  const logout = () => {
    setUser(null);
    sessionStorageUtil.clearUserData();
    sessionStorageUtil.clearAccessToken();
  };

  const value = useMemo(
    () => ({
      user,
      loading,
      setUser,
      login,
      logout,
    }),
    [user, login, logout, loading],
  );

  useEffect(() => {
    const refreshAccessToken = async () => {
      try {
        setLoading(true);

        await new Promise((res) => {
          setTimeout(() => res(), 1500);
        });

        const token = sessionStorageUtil.getAccessToken();

        if (token !== null && token !== "") {
          // return {};

          const userData = sessionStorageUtil.getUserData();

          if (userData !== null) {
            // setUser(userData);
          } else {
            // setUser(null);
            sessionStorageUtil.clearUserData();
            sessionStorageUtil.clearAccessToken();
          }
        } else {
          // setUser(null);
          sessionStorageUtil.clearUserData();
          sessionStorageUtil.clearAccessToken();
        }
      } finally {
        setLoading(false);
      }
    };

    refreshAccessToken();
  }, [user]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth should be used with in AuthProvider");
  }

  return context;
};

export default AuthProvider;
